export default __webpack_public_path__ + "media/flavours/glitch/images/wave-drawer-500b968810ca19a639dd8ab9929f2e19.png";